import script from "./MainFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainFooter.vue?vue&type=script&setup=true&lang=ts"

import "./MainFooter.vue?vue&type=style&index=0&id=b77d4202&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b77d4202"]])

export default __exports__